import z from "zod/v4";

const AI_PROVIDER_PREFIXES = ["openai:", "google:", "anthropic:"] as const;

export const LanguageModelSchema = z
  .string()
  .refine(
    (val) => AI_PROVIDER_PREFIXES.some((prefix) => val.startsWith(prefix)),
    {
      message:
        'Language model must start with "openai:", "google:", or "anthropic:"',
    }
  );
export type LanguageModel =
  | `openai:${string}`
  | `google:${string}`
  | `anthropic:${string}`;

export type JSONValue =
  | string
  | number
  | boolean
  | null
  | JSONValue[]
  | { [key: string]: JSONValue };

export const JSONValueSchema: z.ZodType<JSONValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JSONValueSchema),
    z.record(z.string(), JSONValueSchema),
  ])
);

export {
  SupportedAiModels,
  SupportedAnthropicModels,
  SupportedGoogleModels,
  SupportedOpenAiModels,
} from "./supported-models.generated";

/** Default model for workflow LLM nodes */
export const DEFAULT_WORKFLOW_MODEL = "openai:gpt-5.6-sol" as const;
